import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
var Reviews = /*#__PURE__*/function (_Component) {
  function Reviews(props) {
    var _this;
    _classCallCheck(this, Reviews);
    _this = _callSuper(this, Reviews, [props]);
    _this.state = {
      expanded: false
    };
    _this.toggleShowMore = _this.toggleShowMore.bind(_this);
    return _this;
  }
  _inherits(Reviews, _Component);
  return _createClass(Reviews, [{
    key: "toggleShowMore",
    value: function toggleShowMore() {
      var expanded = this.state.expanded;
      this.setState({
        expanded: !expanded
      });
    }
  }, {
    key: "renderSeeMore",
    value: function renderSeeMore() {
      var expanded = this.state.expanded;
      return /*#__PURE__*/React.createElement("div", {
        className: "mt-2"
      }, /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 expand-projects",
        onClick: this.toggleShowMore,
        role: "link",
        tabIndex: 0
      }, expanded ? 'See Less' : 'View all testimonials'));
    }
  }, {
    key: "render",
    value: function render() {
      var expanded = this.state.expanded;
      var reviews = this.props.reviews;
      var visibleReviews = expanded ? reviews : reviews.slice(0, 3);
      return /*#__PURE__*/React.createElement("div", {
        className: "reviews",
        id: "reviews"
      }, /*#__PURE__*/React.createElement("div", {
        className: "reviews-overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always header"
      }, /*#__PURE__*/React.createElement("h2", null, "Testimonials"))), /*#__PURE__*/React.createElement("div", null, visibleReviews.map(function (review) {
        return /*#__PURE__*/React.createElement("div", {
          className: "review",
          key: review.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "g-row--always mb-12"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "project-name"
        }, review.project || 'Consultant Review')), review.rating && [/*#__PURE__*/React.createElement(StarRatings, {
          rating: parseFloat(review.rating),
          starRatedColor: "#FED500",
          starHoverColor: "#FED500",
          starEmptyColor: "#FFFFFF",
          starDimension: "16px",
          starSpacing: "0px",
          numberOfStars: 1,
          name: "project_rating",
          key: "".concat(review.id, "-star")
        }), /*#__PURE__*/React.createElement("span", {
          className: "rating",
          key: "".concat(review.id, "-rating")
        }, review.rating)], review.public_comment && /*#__PURE__*/React.createElement("p", {
          className: "comment mb-2"
        }, "\"", review.public_comment, "\""), review.company && /*#__PURE__*/React.createElement("h5", null, "- ".concat(review.company)));
      }), reviews.length > 3 ? this.renderSeeMore() : ''));
    }
  }]);
}(Component);
Reviews.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Reviews;